import update from 'immutability-helper';
// eslint-disable-next-line import/no-cycle
import {
  COURSES_PROGRESS,
  COURSES_SUCCESS,
  COURSES_FAILED,
  COURSES_GET_LIST_PROGRESS,
  COURSES_GET_LIST_SUCCESS,
  COURSES_GET_LIST_FAILED,
  COURSES_FORM_SUBMIT_PROGRESS,
  COURSES_FORM_SUBMIT_SUCCESS,
  COURSES_FORM_SUBMIT_FAILED,
  COURSES_GET_COURSE_PROGRESS,
  COURSES_GET_COURSE_SUCCESS,
  COURSES_GET_COURSE_FAILED,
  COURSES_GET_ASYNC_DATA_PROGRESS,
  COURSES_GET_ASYNC_DATA_SUCCESS,
  COURSES_GET_ASYNC_DATA_FAILED,
  COURSES_GET_ASYNC_FORM_DATA_PROGRESS,
  COURSES_GET_ASYNC_FORM_DATA_SUCCESS,
  COURSES_GET_ASYNC_FORM_DATA_FAILED,
  COURSES_CLEAR_STATE,
  COURSES_CLEAR_FLASH_MESSAGE,
} from '../actions/coursesAction';

const initialState = {
  loadListStatus: '', // progress/success/failed
  loadActiveStatus: '', // progress/success/failed
  submitStatus: '', // progress/success/failed
  formDataStatus: '', // progress/success/failed
  asyncStatus: '', // progress/success/failed
  list: [],
  pagination: {},
  active: {},
  asyncData: {},
  flash: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case COURSES_GET_LIST_PROGRESS: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: COURSES_PROGRESS },
      });
    }
    case COURSES_GET_LIST_SUCCESS: {
      return update(state, {
        list: { $set: action.payload.list },
        pagination: { $set: action.payload.pagination },
        loadListStatus: { $set: COURSES_SUCCESS },
      });
    }
    case COURSES_GET_LIST_FAILED: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: COURSES_FAILED },
      });
    }
    case COURSES_FORM_SUBMIT_PROGRESS: {
      return update(state, { submitStatus: { $set: COURSES_PROGRESS } });
    }
    case COURSES_FORM_SUBMIT_SUCCESS: {
      return update(state, {
        flash: { $set: action.payload },
        submitStatus: { $set: COURSES_SUCCESS },
      });
    }
    case COURSES_FORM_SUBMIT_FAILED: {
      return update(state, { submitStatus: { $set: COURSES_FAILED } });
    }
    case COURSES_GET_COURSE_PROGRESS: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: COURSES_PROGRESS },
      });
    }
    case COURSES_GET_COURSE_SUCCESS: {
      return update(state, {
        active: { $set: action.payload.course },
        loadActiveStatus: { $set: COURSES_SUCCESS },
      });
    }
    case COURSES_GET_COURSE_FAILED: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: COURSES_FAILED },
      });
    }
    case COURSES_GET_ASYNC_DATA_PROGRESS: {
      return update(state, {
        asyncData: { $set: {} },
        asyncStatus: { $set: COURSES_PROGRESS },
      });
    }
    case COURSES_GET_ASYNC_DATA_SUCCESS: {
      return update(state, {
        asyncData: { $set: action.payload },
        asyncStatus: { $set: COURSES_SUCCESS },
      });
    }
    case COURSES_GET_ASYNC_DATA_FAILED: {
      return update(state, {
        asyncData: { $set: {} },
        asyncStatus: { $set: COURSES_FAILED },
      });
    }
    case COURSES_GET_ASYNC_FORM_DATA_PROGRESS: {
      return update(state, {
        asyncData: { $set: {} },
        formDataStatus: { $set: COURSES_PROGRESS },
      });
    }
    case COURSES_GET_ASYNC_FORM_DATA_SUCCESS: {
      return update(state, {
        asyncData: { $set: action.payload },
        formDataStatus: { $set: COURSES_SUCCESS },
      });
    }
    case COURSES_GET_ASYNC_FORM_DATA_FAILED: {
      return update(state, {
        asyncData: { $set: {} },
        formDataStatus: { $set: COURSES_FAILED },
      });
    }
    case COURSES_CLEAR_STATE: {
      return update(state, {
        loadListStatus: { $set: '' },
        loadActiveStatus: { $set: '' },
        submitStatus: { $set: '' },
        formDataStatus: { $set: '' },
        asyncStatus: { $set: '' },
        list: { $set: [] },
        pagination: { $set: {} },
        active: { $set: {} },
        asyncData: { $set: {} },
      });
    }
    case COURSES_CLEAR_FLASH_MESSAGE: {
      return update(state, {
        flash: { $set: '' },
      });
    }
    default:
      return state;
  }
}
